module.exports = __webpack_public_path__ + "img/bddr_03.33272636.png";